module.exports = "<router-outlet></router-outlet>\n<notifier-container></notifier-container>\n<ngx-spinner></ngx-spinner>\n"